var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WithLoading',{attrs:{"method":_vm.deleteNegativeKeyword},scopedSlots:_vm._u([{key:"default",fn:function({ isLoading, actionMethod }){return [_c('DeleteButton',{attrs:{"is-loading":isLoading},on:{"click":actionMethod}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }